import React, { useState, useEffect } from "react";
import SearchInput from "components/brandHeader/SearchInput";
import { SearchIcon } from "config/Svgs";
import { t } from "i18next";
import LanguageToggler from "features/LanguageToggler";
import FilterSidebar from './filter-sider-bar';
import { FilterIcon } from "../icons";
import { useCatalogContext } from "../../CatalogContext";

const CatalogHeader = () => {
    const {
        loading,
        loadingMore,
        locationInfo,
        searchKeyword,
        selectedFilters,
        setSearchKeyword,
        setSelectedFilters,
        setLocationInfo,
    } = useCatalogContext();

    const [showSearch, setShowSearch] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);

    const handleToggleFilter = (filterName, isSelected) => {
        if (isSelected) {
            const filters = selectedFilters?.filter(filter => filter !== filterName);
            setSelectedFilters(filters);
        } else {
            const filters = [...selectedFilters, filterName];
            setSelectedFilters(filters);
        }
    };

    const handleToggleSubOption = (subOptionValue, isSelected) => {
        if (isSelected) {
            const filters = selectedFilters?.filter(filter => filter !== subOptionValue);
            setSelectedFilters(filters);
        } else {
            const filters = [...selectedFilters, subOptionValue];
            setSelectedFilters(filters);
        }
    };


    const options = [
        {
            icon: <LanguageToggler  className="shadow border" height="1.25rem" width="1.25rem"  />,
            name: "Language",
            onClick: () => {}
        },
        {
        icon: <SearchIcon />,
        name: "Search",
        onClick: () => setShowSearch(!showSearch)
    }, {
        icon: <FilterIcon />,
        name: "Filter",
        onClick: () => setFilterOpen(prev => !prev)  
    }]

    useEffect(() => {
      if (loading || loadingMore) {
        setFilterOpen(false);
        setShowSearch(false);
      }
    }, [loading, loadingMore]);


    return (
        <header className="bg-white/70 backdrop-blur-md border border-white/20 shadow-sm sticky top-0 z-10 w-full h-fit">
            <div className="flex justify-between items-center p-4 shadow-sm border-b border-gray-200">
                <div className="flex gap-2 items-center">
                    <img
                        src={process.env.REACT_APP_COMPANY_LOGO}
                        alt={process.env.REACT_APP_COMPANY_NAME}
                        className="w-10 h-10 object-contain"
                    />
                    <h1 className="text-24x font-bold text-dark-blue-900">{t("Marketplace")}</h1>
                </div>
                <div className="flex gap-2">

                    {/* Language Toggler - rendered separately to avoid nested button warning */}
                    <div className="p-2 rounded-full">
                        <LanguageToggler className="shadow border" height="1.25rem" width="1.25rem" />
                    </div>

                    {/* Other options (Search, Filter) */}
                    {
                        options?.filter(option => option?.name !== "Language").map(option => (
                            <button
                                key={option?.name}
                                onClick={option?.onClick}
                                className="p-2 rounded-full "
                            >
                                {option?.icon}
                            </button>
                        ))
                    }
                </div>
            </div>
            {(showSearch) && (
                <div
                    className="p-4 w-full shadow-sm"
                    style={{
                        background: "rgb(156 163 175 / 3%)",
                    }}
                >
                    {showSearch && (
                        <SearchInput
                            placeholder="Search by brands, stores , products..."
                            onSearch={(value) => setSearchKeyword(value)}
                            value={searchKeyword}
                            containerClassName="bg-white"
                            clearSearch={false}
                        />
                    )}
                </div>
            )}

            {/* Right-side filter sidebar */}
            <FilterSidebar
                open={filterOpen}
                selectedFilters={selectedFilters}
                locationInfo={locationInfo}
                onClose={() => setFilterOpen(false)}
                setLocationInfo={setLocationInfo}
                onToggleFilter={handleToggleFilter}
                onToggleSubOption={handleToggleSubOption}
            />
        </header>
    );
};

export default CatalogHeader;
